import { useState } from "react";

const navItems = [
  { label: "热点词索引", href: "#hot-words" },
  { label: "热度榜", href: "#rank" },
  { label: "专题合集", href: "#collections" },
  { label: "人物查询", href: "#persons" },
  { label: "黑料索引", href: "#zones" },
  { label: "最新爆料", href: "#latest" },
];

export default function TopBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:h-[68px] md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="18黑料网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            18
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
            18黑料网
          </h1>
          <span className="hidden rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900 lg:inline-block">
            关键词索引
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <form
          className="hidden items-center gap-2 md:flex"
          onSubmit={(event) => event.preventDefault()}
          role="search"
        >
          <div className="flex h-10 items-center gap-2 rounded-md border border-background-300/70 bg-background-100/70 px-3">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              name="navKeyword"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索关键词或人物"
              className="w-32 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 xl:w-48"
            />
          </div>
          <button
            type="submit"
            className="h-10 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            检索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-800 lg:hidden"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <form
            className="mt-4 flex items-center gap-2"
            onSubmit={(event) => event.preventDefault()}
            role="search"
          >
            <div className="flex h-10 flex-1 items-center gap-2 rounded-md border border-background-300/70 bg-background-100/70 px-3">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-base" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                name="mobileKeyword"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索关键词或人物"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </div>
            <button
              type="submit"
              className="h-10 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 text-sm font-medium text-background-50"
            >
              检索
            </button>
          </form>
        </div>
      )}
    </header>
  );
}